import React from 'react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Laptop, Moon, Sun } from 'lucide-react'
import { useTheme, type ThemeMode } from '@/hooks/use-theme'

export default function ThemeToggle() {
  const { theme, resolved, setTheme } = useTheme()

  const Icon = resolved === 'dark' ? Moon : Sun
  const label =
    theme === 'system' ? 'System theme' : theme === 'dark' ? 'Dark theme' : 'Light theme'

  const onChange = (value: string) => setTheme((value as ThemeMode) ?? 'system')

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label="Toggle theme"
          title={label}
        >
          <Icon className="h-4 w-4" aria-hidden="true" />
          <span className="sr-only">Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>Theme</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuRadioGroup value={theme} onValueChange={onChange}>
          <DropdownMenuRadioItem value="light">
            <div className="flex items-center gap-2">
              <Sun className="h-4 w-4" aria-hidden="true" />
              Light
            </div>
          </DropdownMenuRadioItem>
          <DropdownMenuRadioItem value="dark">
            <div className="flex items-center gap-2">
              <Moon className="h-4 w-4" aria-hidden="true" />
              Dark
            </div>
          </DropdownMenuRadioItem>
          <DropdownMenuRadioItem value="system">
            <div className="flex items-center gap-2">
              <Laptop className="h-4 w-4" aria-hidden="true" />
              System
            </div>
          </DropdownMenuRadioItem>
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

